import SearchIcon from '@mui/icons-material/Search'
import {
  Box,
  type BoxProps,
  Button,
  Input,
  InputAdornment,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import Stack from '@mui/material/Stack'
import { useRouter } from 'next/router'
import { memo } from 'react'

import useTrans from '@/hooks/useTrans'

type BarProps = BoxProps & {
  inputValue?: string
  setInputValue?: (inputValue: string) => void
  tabActive: 'pools' | 'portfolio'
}

const Bar = ({ inputValue, setInputValue, tabActive, ...props }: BarProps) => {
  const router = useRouter()
  const trans = useTrans()
  const redirectTab = (tab: string) => {
    if (tab !== tabActive) {
      router.replace(`/liquidity/${tab === 'pools' ? 'browse' : 'portfolio'}`)
    }
  }
  const isSmallScreen = useMediaQuery(useTheme().breakpoints.down('sm'))

  return (
    <Stack
      direction={isSmallScreen ? 'column' : 'row'}
      className="h-full"
      alignItems={isSmallScreen ? 'normal' : 'center'}
      justifyContent="space-between"
      spacing={isSmallScreen ? 2 : 1}
      {...props}
    >
      <Stack direction="row" spacing={1}>
        <Stack direction="column" className="w-full">
          <Button
            data-testid="btn-nav-pools"
            onClick={() => redirectTab('pools')}
            fullWidth
            className="py-3 px-4"
          >
            <Typography
              sx={{
                color: tabActive === 'pools' ? '#FFFFFF' : '#888C9E',
                fontWeight: 600,
              }}
              textTransform="none"
              whiteSpace="nowrap"
            >
              {trans.liquidity.bar.pools}
            </Typography>
          </Button>
          <Box
            sx={{ height: 2 }}
            className={tabActive === 'pools' ? 'bg-gradient-btn' : ''}
          />
        </Stack>
        <Stack direction="column" className="w-full">
          <Button
            data-testid="btn-nav-portfolio"
            onClick={() => redirectTab('portfolio')}
            fullWidth
            className="py-3 px-4"
          >
            <Typography
              sx={{
                color: tabActive === 'portfolio' ? '#FFFFFF' : '#888C9E',
                fontWeight: 600,
              }}
              textTransform="none"
              whiteSpace="nowrap"
            >
              {trans.liquidity.bar.positions}
            </Typography>
          </Button>
          <Box
            sx={{ height: 2 }}
            className={tabActive === 'portfolio' ? 'bg-gradient-btn' : ''}
          />
        </Stack>
      </Stack>
      {tabActive === 'pools' && (
        <Stack direction={isSmallScreen ? 'column-reverse' : 'row'} alignItems="flex-start" spacing={2}>
          <Input
            data-testid="input-search-mint-address"
            className="border border-solid border-[#61667E] bg-[#2A3748] rounded-lg p-2 text-sm sm:w-56 md:w-80 lg:w-96"
            disableUnderline
            placeholder={trans.liquidity.pool_search_placeholder}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
            inputProps={{
              className: 'p-0 pr-3 text-md',
            }}
            onChange={(e) => setInputValue?.(e.target.value)}
            value={inputValue}
            style={isSmallScreen ? { width: '100%' } : undefined}
          />
        </Stack>
      )}
    </Stack>
  )
}

export default memo(Bar)
